import { Breadcrumb, Container } from "react-bootstrap";
import { Outlet, useLocation } from "react-router-dom";

const MDFeCadastroView = () => {
  const { pathname } = useLocation();

  const steps = [
    { label: "Identificação", path: `/fiscal/mdfe/cadastro/identificacao` },
    { label: "Percurso", path: `/fiscal/mdfe/cadastro/percurso` },
    { label: "Veículo & Condutores", path: `/fiscal/mdfe/cadastro/veiculo` },
    { label: "Carregamento", path: `/fiscal/mdfe/cadastro/carregamento` },
    { label: "Documentos", path: `/fiscal/mdfe/cadastro/documentos` },
    { label: "Totais & Seguros", path: `/fiscal/mdfe/cadastro/totais` },
    { label: "Pagamento", path: `/fiscal/mdfe/cadastro/pagamento` },
    { label: "Contratantes", path: `/fiscal/mdfe/cadastro/contratantes` },
    { label: "Finalização", path: `/fiscal/mdfe/cadastro/finalizacao` },
  ];

  const currentIndex = steps.findIndex((s) => pathname.startsWith(s.path));
  const visibleSteps = steps.slice(0, currentIndex + 1);
  const ellipsisIndex = { label: "...", path: "ellipsis" };
  const showSteps =
    visibleSteps.length > 3
      ? [ellipsisIndex, ...visibleSteps.slice(-3)]
      : visibleSteps;

  return (
    <Container>
      <Breadcrumb className="mt-3">
        {showSteps.map((step) => {
          const isComplete = visibleSteps.indexOf(step) < currentIndex;

          if (step.path === "ellipsis") {
            return (
              <Breadcrumb.Item
                linkAs="span"
                key="ellipsis"
                active={false}
                className={isComplete ? "text-success" : ""}
              >
                ...
              </Breadcrumb.Item>
            );
          }

          const isActive = pathname === step.path;

          return (
            <Breadcrumb.Item
              key={step.path}
              linkAs="span"
              linkProps={isActive ? {} : { href: step.path }}
              active={isActive}
              className={isComplete ? "text-success" : ""}
            >
              {step.label}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
      <Outlet />
    </Container>
  );
};

export default MDFeCadastroView;
